// extracted by mini-css-extract-plugin
export default {"apps":"AccountAppsDetail_apps__QqSbP","back-link":"AccountAppsDetail_back-link__IAxwr","title":"AccountAppsDetail_title__Cf0IZ","button":"AccountAppsDetail_button__a2fKq"};